import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

const CLIENTS_KEY = KEYS.client.clients.detail();

type Props = {
  ticketClientId?: number;
};

function useGetClientsDetail({ ticketClientId }: Props) {
  const { showApiError } = useGlobalContext();
  const { client: clientApi } = useApiContext();
  const { t } = useTranslation('global');

  const clientsDetail = useQuery(
    [CLIENTS_KEY, ticketClientId],
    () => clientApi.clients.detail(ticketClientId),
    {
      select: (data) => data?.data?.data,
      enabled: !!ticketClientId,
      onError: (error) => showApiError(error, t('errorMessages.clientDetail')),
      refetchOnWindowFocus: false
    }
  );

  return {
    clientsDetail
  };
}

export default useGetClientsDetail;
